namespace $.$$ {

	$mol_style_define( $shm_wordstat_task_list, {
		width: '16rem',
		flex: { basis: '16rem', grow: 0, shrink: 0 },

		Tasks: {
			flex: {
				direction: 'column',
				grow: 1,
			},
		},

		List_head: {
			flex: {
				grow: 1,
			},
		},

		Task_link: {
			width: '100%',
			justifyContent: 'flex-start',
		},

		Add_foot: {
			width: '100%',
			justifyContent: 'center',
			border: {
				radius: $mol_gap.round,
			},
			padding: $mol_gap.text,
		},
	} )

}
